var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"onlitxswd"},[_c('div',{staticClass:"xswdtitl"},[_vm._v("相似问答")]),_c('ul',_vm._l((5),function(item){return _c('li',{key:item,staticClass:"ellipsis"},[_vm._v(" 我之前打给他人的借条、但是把欠但是 ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }